import { queryClient } from '@/config/query-client.config';
import {
  CreateIdentifiedSymptomRequest,
  UpdateIdentifiedSymptomRequest,
} from '@repo/types/src/identified-symptom';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createIdentifiedSymptom,
  deleteIdentifiedSymptom,
  getAllIdentifiedSymptoms,
  updateIdentifiedSymptom,
} from './identified-symptom.queries';
import { identifiedSymptomQueryKeys } from './identified-symptom.query-keys';

export const useGetIdentifiedSymptoms = () => {
  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: identifiedSymptomQueryKeys.all,
    queryFn: getAllIdentifiedSymptoms,
  });

  return {
    identifiedSymptoms: data || [],
    isError,
    isLoading,
    refetch,
  };
};

export const useCreateIdentifiedSymptom = () => {
  return useMutation({
    mutationFn: (payload: CreateIdentifiedSymptomRequest) =>
      createIdentifiedSymptom(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: identifiedSymptomQueryKeys.all,
      });
    },
  });
};

export const useUpdateIdentifiedSymptom = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateIdentifiedSymptomRequest;
    }) => updateIdentifiedSymptom(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: identifiedSymptomQueryKeys.all,
      });
    },
  });
};

export const useDeleteIdentifiedSymptom = () => {
  return useMutation({
    mutationFn: (id: number) => deleteIdentifiedSymptom(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: identifiedSymptomQueryKeys.all,
      });
    },
  });
};
